import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#FFF"
    }, [
      _createElementVNode("path", { d: "m.5 22.5 7-7m8-8 7-7m0 22-7-7m-8-8-7-7" }),
      _createElementVNode("path", {
        "stroke-linecap": "square",
        d: "M21.5 7.5h-6v-6m-14 14h6v6m0-20v6h-6m14 14v-6h6"
      })
    ], -1)
  ]))]))
}
export default { render: render }